import { useEffect, useState } from 'react';

interface Properties {
  readonly isLoading: boolean;
  readonly delay?: number;
}

// Prevent frequent mounting and unmounting of the loading state
// This avoids the spinner from flickering or restarting repeatedly
const useDelayedIsLoading = ({ isLoading }: Properties): boolean => {
  const [delayedIsLoading, setDelayedIsLoading] = useState(isLoading);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    if (isLoading) {
      queueMicrotask(() => {
        setDelayedIsLoading(true);
      });
    } else {
      timeoutId = setTimeout(() => {
        setDelayedIsLoading(false);
      }, 100);
    }

    return () => clearTimeout(timeoutId);
  }, [isLoading]);

  return delayedIsLoading;
};

export default useDelayedIsLoading;
